(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/racing/player-service/assets/javascripts/player-service.js') >= 0) return;  svs.modules.push('/components/racing/player-service/assets/javascripts/player-service.js');

'use strict';

const format = dateFns.format;
const logger = svs.core.log.getLogger('racing:player-service');
const normalizeWagers = svs.racing.playerService.utils.normalize.normalizeWagers;
const normalizeRace = svs.racing.raceService.utils.normalize.normalizeRace;
const {
  gameTypeToSubProductId
} = svs.racing.common.constants;
function fetchWagersBase(jupiterOptions, callback) {
  svs.core.jupiter.get(jupiterOptions, response => {
    const lastFetched = format(new Date(), 'HH:mm');
    callback(null, normalizeWagers(response), lastFetched, response.moreItems);
  }, error => {
    callback(error);
  });
}
const fetchWagers = (options, callback) => {
  if (typeof options !== 'object') {
    return callback(new Error('Expected object of options'));
  }
  if (options.amountToFetch < 1 || !options.status) {
    return callback(new Error('Missing parameter to function'));
  }
  let path = "/player/1/wagers?status=".concat(options.status, "&productId=RX&count=").concat(options.amountToFetch);
  const subProductId = gameTypeToSubProductId[options.type];
  if (subProductId) {
    path += "&subproductId=".concat(subProductId);
  }
  fetchWagersBase({
    path
  }, callback);
};
const fetchWagersByPageId = (options, callback) => {
  if (typeof options !== 'object') {
    return callback(new Error('Expected object of options'));
  }
  if (!options.status || !options.pageId) {
    return callback(new Error('Missing parameter to function'));
  }
  fetchWagersBase({
    path: "/player/1/wagers?status=".concat(options.status, "&productId=RX&pagingSortKey=").concat(options.pageId, "&count=20")
  }, callback);
};
const fetchWager = (wagerId, callback) => {
  if (!wagerId) {
    return callback(new Error('Missing parameter to function'));
  }
  const options = {
    path: "/player/1/wagers/".concat(wagerId)
  };
  svs.core.jupiter.get(options, response => {
    callback(null, response);
  }, error => {
    callback(error);
  });
};
const fetchDraw = (wagerResponse, callback) => {
  const drawNum = wagerResponse.wager.wager.bets[0].drawNum;
  const options = {
    path: "/racing/1/race/draw/".concat(drawNum)
  };
  svs.core.jupiter.get(options, response => {
    callback(null, wagerResponse, normalizeRace(response.race));
  }, error => {
    callback(error);
  });
};
const fetchContainerWithDraw = (wager, callback) => {
  if (!wager.properties.groupId) {
    return;
  }
  const options = {
    path: "/marketplace/1/wagerdetails/".concat(wager.properties.groupId, "?wagerId=").concat(wager.wagerId)
  };
  svs.core.jupiter.get(options, response => {
    callback(null, response);
  }, err => {
    callback(err);
  });
};
const fetchWagerAndDraw = (wagerId, finalCallback) => {
  async.waterfall([callback => {
    fetchWager(wagerId, callback);
  }, (wagerResponse, callback) => {
    fetchDraw(wagerResponse, callback);
  }], (error, wagerResponse, drawResponse) => {
    if (error) {
      logger.error('Error fetching wager and draw: ', error);
      finalCallback(error);
    } else {
      finalCallback(null, wagerResponse, drawResponse);
    }
  });
};
const setExamineWager = (wagerId, drawNum, callback) => {
  const data = {
    drawNum,
    examinedSerial: wagerId,
    productId: 'RX'
  };
  svs.components.payment.examineWager.examine(data, error => {
    if (!error) {
      logger.log('Wager examined: ok');
    } else {
      logger.error('Something went wrong: ', error);
    }
    const didError = Boolean(error);
    callback(didError);
  });
};
svs.racing.playerService.setExamineWager = setExamineWager;
svs.racing.playerService.fetchWagerAndDraw = fetchWagerAndDraw;
svs.racing.playerService.fetchWagers = fetchWagers;
svs.racing.playerService.fetchWagersByPageId = fetchWagersByPageId;
svs.racing.playerService.fetchContainerWithDraw = fetchContainerWithDraw;

svs.racing.playerService.fetchWager = fetchWager;

 })(window);